const _config = {
    dom: {
        defaultTag: "div",
        specialDom: ["body", "head", "html"],
    },
    modules: {
        ajax: {
            successCode: [200],
            // default timeout
            timeout: 5000,
            // return false to stop the request
            hooks: {
                // => ajax::Ajax
                before: (ajax) => ajax || true,
                // => ajax::Ajax
                success: (ajax) => ajax || true,
                // => ajax::Ajax
                failed: (ajax) => ajax || true,
                // => ajax::Ajax, data::Object
                callback: (ajax, data) => ajax || data || true,
            },
        },
    },
};

var _dev = {
    _dom: document || null,
    newWarn(send, warn, file) {
        // if file
        if (file) {
            // clear empty strings
            file = file.filter((e) => e);
        }
        // if in dev
        let output = `[Fastjs warn] ${send}: ${warn}`;
        if (file) {
            output += "\n";
            file.forEach((v) => {
                output += `   |-> ${v}\n`;
            });
        }
        // new warn
        console.warn(output);
    },
    newError(send, error, file) {
        // if file
        if (file) {
            // clear empty strings
            file = file.filter((e) => e);
        }
        // if in dev
        let output = `[${send}] ${error}`;
        if (file) {
            output += "\n";
            file.forEach((v) => {
                output += `   |-> ${v}\n`;
            });
        }
        // new error
        const err = new Error(output);
        err.name = "FastjsError";
        return err;
    },
    type(arg) {
        let type = typeof arg;
        if (type === "object") {
            if (arg instanceof Element)
                type = "Element";
            // if null
            else if (arg === null)
                type = "Null";
            else
                type = arg.constructor.name;
        }
        return type;
    },
};

class FastjsAjax {
    constructor(url, data, config = {}) {
        this.url = url;
        this.data = data || {};
        this.config = {
            timeout: config.timeout || _config.modules.ajax.timeout,
            datatype: config.datatype || "auto",
            headers: config.headers || {},
            shutdown: config.shutdown || false,
            wait: config.wait || 0,
            failed: config.failed || (() => 0),
            callback: config.callback || (() => 0),
            keepalive: config.keepalive || false,
            keepaliveWait: config.keepaliveWait || 0
        };
        this.response = null;
        this.xhr = null;
        this.waitId = 0;
        // construct
        this.construct = "FastjsAjax";
    }
    get(data = {}) {
        return this.send("GET", data, "FastjsAjax.get()");
    }
    post(data = {}) {
        return this.send("POST", data, "FastjsAjax.post()");
    }
    send(method, data = {}, referer = "FastjsAjax.send()") {
        const config = _config.modules.ajax;
        return new Promise((resolve, reject) => {
            // method to uppercase
            method = method.toUpperCase();
            const next = () => {
                const tryJson = (data) => {
                    try {
                        return JSON.parse(data);
                    }
                    catch (e) {
                        return data;
                    }
                };
                // if xhr and shutdown is true
                if (this.xhr !== null && this.config.shutdown) {
                    return;
                }
                // create xhr
                let xhr = new XMLHttpRequest();
                this.xhr = xhr;
                let url = this.url;
                if (method === "GET" && Object.keys(this.data).length > 0) {
                    for (const key in this.data) {
                        if (this.data.hasOwnProperty(key)) {
                            const value = this.data[key];
                            url += `${url.includes("?") ? "&" : "?"}${key}=${encodeURIComponent(value)}`;
                        }
                    }
                }
                xhr.open(method, url, true);
                // set header
                for (let key in this.config.headers) {
                    xhr.setRequestHeader(key, this.config.headers[key]);
                }
                xhr.timeout = this.config.timeout;
                const fail = (from) => {
                    var _a, _b, _c, _d;
                    const result = ((_a = this.xhr) === null || _a === void 0 ? void 0 : _a.status) === 0 && false || tryJson((_b = this.xhr) === null || _b === void 0 ? void 0 : _b.response);
                    // hook
                    if (config.hooks.failed(this) === false)
                        return;
                    // run failed
                    this.config.failed(this);
                    // if keepalive
                    if (this.config.keepalive) {
                        setTimeout(next, this.config.keepaliveWait);
                    }
                    let err;
                    switch (true) {
                        case ((_c = this.xhr) === null || _c === void 0 ? void 0 : _c.status) === 0:
                            err = "Request failed";
                            break;
                        default:
                            err = `Request failed with status ${(_d = this.xhr) === null || _d === void 0 ? void 0 : _d.status}`;
                    }
                    const errOutput = _dev.newError("FastjsAjax", err, [
                        err,
                        "trig -> fail()",
                        from || "",
                        referer ? `${referer} -> send()` : "",
                        "url: " + this.url,
                    ]);
                    reject(result || errOutput);
                    console.error(errOutput);
                };
                // xhr failed
                xhr.onreadystatechange = () => {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 0)
                            fail("xhr -> onreadystatechange()");
                        else
                            load();
                    }
                };
                xhr.onerror = () => fail;
                xhr.ontimeout = () => fail;
                // xhr load
                const load = () => {
                    if (xhr.status !== 200) {
                        return void fail("xhr -> onreadystatechange() -> load()");
                    }
                    const data = this.config.datatype === "auto" && tryJson(xhr.response) || xhr.response;
                    if (config.hooks.success(this) === false)
                        return;
                    if (config.hooks.callback(this, data) === false)
                        return;
                    this.config.callback(data, this);
                    // if keepalive
                    if (this.config.keepalive) {
                        setTimeout(next, this.config.keepaliveWait);
                    }
                    resolve(data);
                };
                let data = "";
                if (method === "POST") {
                    data = JSON.stringify(this.data);
                    xhr.setRequestHeader("Content-Type", "application/json");
                }
                xhr.send(data || null);
            };
            // if wait
            if (this.config.wait > 0) {
                if (this.waitId !== 0) {
                    clearTimeout(this.waitId);
                }
                // do debounce
                this.waitId = Number(setTimeout(() => {
                    next();
                    this.waitId = 0;
                }, this.config.wait));
            }
            else
                next();
        });
    }
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

var _FastjsDate_date, _FastjsDate_createAt;
class FastjsDate {
    constructor(format, date = new Date().getTime()) {
        /*
         * Y = year
         * M = month
         * D = day
         *
         * H = hour (12)
         * A = AM/PM
         * a = am/pm
         * h = hour (24)
         * hh = hour (24) without 0
         * m = minute
         * mm = minute without 0
         * s = second
         * ss = second without 0
         * S = millisecond
         *
         * <any> to ignore (eg. "<date>: Y-M-D h:m:s")
         */
        _FastjsDate_date.set(this, void 0);
        _FastjsDate_createAt.set(this, void 0);
        this.format = format;
        __classPrivateFieldSet(this, _FastjsDate_date, date, "f");
        __classPrivateFieldSet(this, _FastjsDate_createAt, new Date().getTime(), "f");
        this.construct = "FastjsDate";
    }
    toString(newFormat) {
        let timestamp = this.toNumber();
        const date = new Date(timestamp);
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const hourDefault = date.getHours();
        const minuteDefault = date.getMinutes();
        const secondDefault = date.getSeconds();
        const millisecond = date.getMilliseconds();
        const ampm = hourDefault >= 12 ? "PM" : "AM";
        const ampm2 = hourDefault >= 12 ? "pm" : "am";
        const hour12 = hourDefault % 12;
        // add 0
        const hour = hourDefault < 10 ? "0" + hourDefault : hourDefault.toString();
        const minute = minuteDefault < 10 ? "0" + minuteDefault : minuteDefault.toString();
        const second = secondDefault < 10 ? "0" + secondDefault : secondDefault.toString();
        let string = newFormat || this.format;
        // ignore
        let token = 0;
        let ignoreTemp = [];
        // check ignore format
        while (/<.*?>/.test(string)) {
            const match = string.match(/<.*?>/);
            if (match === null)
                break;
            // get user ignore text
            const matchString = match[0];
            // noinspection UnnecessaryLocalVariableJS
            const exactString = matchString
                .replace(/</g, "")
                .replace(/>/g, "");
            ignoreTemp[token] = exactString;
            // replace ignore text to token
            string = string.replace(/<.*?>/, `{{*${token}}}`);
            token++;
        }
        // replace format
        const replaceFormatList = [
            ["Y", year],
            ["M", month],
            ["D", day],
            ["H", hour12],
            ["A", ampm],
            ["a", ampm2],
            ["hh", hourDefault],
            ["h", hour],
            ["mm", minuteDefault],
            ["m", minute],
            ["ss", secondDefault],
            ["s", second],
            ["S", millisecond],
        ];
        replaceFormatList.forEach((e) => {
            // replace keyword
            string = string.replaceAll(e[0], String(e[1]));
        });
        // replace ignore
        ignoreTemp.forEach((ignoreText, key) => {
            string = string.replace(`{{*${key}}}`, ignoreText);
        });
        return string;
    }
    toNumber() {
        const timeLeft = new Date().getTime() - __classPrivateFieldGet(this, _FastjsDate_createAt, "f");
        return __classPrivateFieldGet(this, _FastjsDate_date, "f") + timeLeft;
    }
    toStringLocal(newFormat) {
        return new FastjsDate(newFormat || this.format, __classPrivateFieldGet(this, _FastjsDate_date, "f")).toString();
    }
    toNumberLocal() {
        return __classPrivateFieldGet(this, _FastjsDate_date, "f");
    }
}
_FastjsDate_date = new WeakMap(), _FastjsDate_createAt = new WeakMap();

var _FastjsArray_instances, _FastjsArray_hooks, _FastjsArray_check;
class FastjsArray {
    constructor(array = [], config = {}) {
        /*
            config = {
                type: <string>::type / <array>::type,
                length: <number>::max length
            }
        */
        _FastjsArray_instances.add(this);
        _FastjsArray_hooks.set(this, void 0);
        this._array = new Proxy(array, {
            set: (target, key, value) => {
                if (!__classPrivateFieldGet(this, _FastjsArray_instances, "m", _FastjsArray_check).call(this, value))
                    return false;
                // @ts-ignore
                target[key] = value;
                // run hooks
                __classPrivateFieldGet(this, _FastjsArray_hooks, "f").forEach((e) => {
                    e(this);
                });
                return true;
            },
        });
        config = this._config = {
            type: config.type || "Any",
            length: config.length || null,
        };
        // init hooks
        __classPrivateFieldSet(this, _FastjsArray_hooks, [], "f");
        // construct
        this.construct = `<${config.type}>FastjsArray`;
        return new Proxy(this, {
            get: (target, key) => {
                // is number
                if (!isNaN(Number(key))) {
                    return target._array[Number(key)];
                }
                // FastjsArray.prototype --> Array.prototype --> Object.prototype --> null
                else if (target[key] === undefined) {
                    // try find from this._array
                    if (key in Array.prototype) {
                        // is func
                        if (typeof Array.prototype[key] === "function") {
                            return (...args) => {
                                return Array.prototype[key].apply(target._array, args);
                            };
                        }
                        return this._array[key];
                    }
                }
                else
                    return target[key];
            },
            set: (target, key, value) => {
                // find from array
                if (!isNaN(Number(key))) {
                    target._array[Number(key)] = value;
                }
                return true;
            }
        });
    }
    first() {
        return this._array[0];
    }
    last() {
        return this._array[this._array.length - 1];
    }
    add(val, key = this._array.length) {
        this._array.splice(key, 0, val);
        return this;
    }
    remove(key) {
        this._array.splice(key, 1);
        return this;
    }
    each(callback) {
        this._array.forEach((e, key) => {
            callback(e, key);
        });
        return this;
    }
    toArray() {
        // throw proxy
        return Object.assign([], this._array);
    }
    then(callback, time = 0) {
        if (time)
            setTimeout(() => {
                callback(this);
            }, time);
        else
            callback(this);
        return this;
    }
    addHook(callback) {
        __classPrivateFieldGet(this, _FastjsArray_hooks, "f").push(callback);
        return this;
    }
}
_FastjsArray_hooks = new WeakMap(), _FastjsArray_instances = new WeakSet(), _FastjsArray_check = function _FastjsArray_check(item) {
    let cfg = this._config;
    // check length
    if (cfg.length && this._array.length >= cfg.length) {
        return void console.error(_dev.newError("FastjsArray", `Max length of <${cfg.type}>FastjsArray is ` + cfg.length, ["check(item)", "FastjsArray"]));
    }
    // check type
    const reject = () => {
        // dev start
        console.error(_dev.newError("FastjsArray", `TypeError: ${type}${item} cannot be a item of <${cfg.type}>FastjsArray`, ["reject()", "check(item)", "FastjsArray"]));
        // dev end
        return false;
    };
    let type = _dev.type(item);
    if (cfg.type !== "Any") {
        // if cfg.type is array -> multi type
        if (Array.isArray(cfg.type)) {
            // if type is not in cfg.type ** ignore case
            if (!cfg.type.some((v) => v.toLowerCase() === type.toLowerCase())) {
                return reject();
            }
        }
        // else
        else if (type.toLowerCase() !== cfg.type.toLowerCase()) {
            return reject();
        }
    }
    return true;
};

class FastjsBind {
    constructor(el, bind, key, object = {}, isAttr = false) {
        let effect = (target) => {
            return new Proxy(target, {
                set(target, p, value) {
                    if (target._event) {
                        // set value -> pass
                        target[key] = value;
                        // do event
                        if (target._event[key] && key !== "_event") {
                            target._event[key].forEach((e) => {
                                if (e.attr) {
                                    e._el.attr(e.bind, value);
                                }
                                else {
                                    e._el.set(e.bind, value);
                                }
                            });
                        }
                    }
                    return true;
                }
            });
        };
        if (!object._event) {
            object._event = {};
            // init effect
            // @ts-ignore
            object = effect(object);
        }
        if (!object._event[key])
            object._event[key] = [];
        // find same event & dom
        let same = false;
        object._event[key].forEach((e) => {
            // is same dom & bind
            if (e.bind === bind && e._el._el.isEqualNode(el._el))
                same = true;
        });
        if (same)
            return object;
        object._event[key].push({
            attr: isAttr,
            _el: el,
            bind: bind
        });
        // init
        if (isAttr)
            el.attr(bind, object[key]);
        else
            // @ts-ignore
            el._el[bind] = object[key];
        return object;
    }
}

var _FastjsDomList_effect;
class FastjsDomList {
    constructor(list = []) {
        _FastjsDomList_effect.set(this, void 0);
        let domList = [];
        list === null || list === void 0 ? void 0 : list.forEach((el) => {
            domList.push(new FastjsDom(el));
        });
        this._list = new Proxy(domList, {
            set: (target, key, value) => {
                target[Number(key)] = value;
                __classPrivateFieldGet(this, _FastjsDomList_effect, "f").call(this);
                return true;
            }
        });
        this.length = 0;
        // effect
        __classPrivateFieldSet(this, _FastjsDomList_effect, () => {
            // mount domList: Array<Element> -> this
            this._list.forEach((e, key) => {
                this[key] = e;
            });
            // length
            this.length = this._list.length;
        }, "f");
        __classPrivateFieldGet(this, _FastjsDomList_effect, "f").call(this);
        // construct
        this.construct = 'FastjsDomList';
        return this;
    }
    // methods
    add(el) {
        this._list.push(el instanceof FastjsDom ? el : new FastjsDom(el));
        return this;
    }
    attr(key, value) {
        this._list.forEach((e) => {
            e.attr(key, value);
        });
        return this;
    }
    bind(bind, key, object = {}, isAttr = false) {
        this._list.forEach((e) => {
            object = e.bind(bind, String(key), object, isAttr);
        });
        return object;
    }
    css(key, value, other) {
        this._list.forEach((e) => {
            if (typeof key === 'object')
                e.css(key);
            else {
                e.css(key, value || "", other);
            }
        });
        return this;
    }
    delete(key, deleteDom = false) {
        if (deleteDom)
            this._list[key].remove();
        this._list.splice(key, 1);
        return this;
    }
    each(callback) {
        this._list.forEach((e, index) => {
            callback(e, e.el(), index);
        });
        return this;
    }
    el(key = 0) {
        return this._list[key].el();
    }
    father() {
        return this._list[0].father();
    }
    get(key, index = 0) {
        // get()
        // get a value of element
        return this._list[index || 0].get(key);
    }
    getEl(key = 0) {
        // overflow
        if (key >= this._list.length)
            _dev.newWarn('FastjsDomList', 'key is overflow', [
                'getEl(key)',
                'dataEdit.js',
                'FastjsDomList'
            ]);
        return this._list[key || 0];
    }
    html(val) {
        if (val === undefined)
            return this._list[0].html();
        this._list.forEach((e) => {
            e.html(val);
        });
        return this;
    }
    next(el) {
        return selector(el, this);
    }
    on(event = "click", callback) {
        this._list.forEach((e) => {
            e.on(event, callback);
        });
        return this;
    }
    off(event = "click", callback) {
        this._list.forEach((e) => {
            e.off(event, callback);
        });
        return this;
    }
    remove(key, dontDelete = false) {
        if (key !== undefined) {
            // remove in dom
            this._list[key].remove();
            // delete this[key];
            if (!dontDelete)
                this._list.splice(key, 1);
            return this;
        }
        this._list.forEach((e) => {
            e.remove();
        });
        return null;
    }
    set(key, val, el) {
        if (el === undefined)
            // set for all elements
            this.each((e) => {
                e.set(key, val);
            });
        else
            // getEl(key) -> FastjsDom -> set val
            this.getEl(el).set(key, val);
        return this;
    }
    text(val) {
        if (val === undefined)
            return this._list[0].text();
        return this._list.forEach((e) => {
            e.text(val);
        }), this;
    }
    toArray() {
        return this._list;
    }
    then(callback, time = 0) {
        if (time)
            setTimeout(() => {
                callback(this, this.el());
            }, time);
        else
            callback(this, this.el());
        return this;
    }
    val(val, key) {
        const set = (val, el) => void el.val(val);
        if (typeof val !== 'string')
            return this._list[val || 0].val();
        if (key === undefined) {
            this._list.forEach(el => set(val, el));
        }
        else {
            set(val, this._list[key]);
        }
        return this;
    }
}
_FastjsDomList_effect = new WeakMap();

let fastjs = {
    selector(el, place = _dev._dom) {
        // selector()
        // select elements
        // dom: Element[] :: save elements result
        let dom = [];
        // if place = FastjsDomList
        if (place instanceof FastjsDomList) {
            place._list.forEach((e) => {
                e._el.querySelectorAll(el).forEach((v) => {
                    // check if v is in dom
                    if (!dom.some((v2) => v2 === v))
                        dom.push(v);
                });
            });
        }
        else {
            place
                .querySelectorAll(el)
                .forEach((v) => void dom.push(v));
        }
        // if last selecter is id
        let special = el.split(" ")[el.split(" ").length - 1].startsWith("#");
        // prevent extra forEach
        if (!special)
            _config.dom.specialDom.forEach((v) => {
                if (el.startsWith(v))
                    special = true;
            });
        if (special)
            // -> FastjsDom -> element
            return new FastjsDom(dom[0]);
        // -> FastjsDomList -> FastjsDom -> element
        return new FastjsDomList(dom);
    },
    copy(text) {
        // copy text to clipboard
        let input = new FastjsDom("span");
        input.html(text.replaceAll("\n", "<br>").replaceAll(" ", "&nbsp;")).push();
        // create range to select text
        const range = document.createRange();
        range.setStart(input._el, 0);
        range.setEnd(input._el, input._el.childNodes.length);
        const selection = window.getSelection();
        if (!selection)
            return;
        selection.removeAllRanges();
        selection.addRange(range);
        // copy text
        document.execCommand("copy");
        input.remove();
    },
    rand(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    /*  Beta Feature  */
    install(name) {
        // module
        const install = eval(`new ${name}()`);
        // get all methods
        let methods = Object.entries(install);
        const moduleList = [];
        const methodList = [];
        methods.forEach((v) => {
            // if function and not private
            if (typeof v[1] === "function" && !v[0].startsWith("#"))
                // add to moduleList
                moduleList.push(v);
        });
        moduleList.forEach((v) => {
            methodList.push((obj) => {
                // fade class
                const fade = eval(`new ${module}(${obj})`);
                // do method
                return fade[v[0]](...Array.from(arguments).slice(1));
            });
        });
        // @ts-ignore
        return methodList;
    },
};
const { selector, copy, rand } = fastjs;

var _FastjsDom_event;
class FastjsDom {
    constructor(el) {
        _FastjsDom_event.set(this, []);
        // if string
        if (typeof el === "string") {
            // create element
            el = _dev._dom.createElement(el);
        }
        // define _el
        this._el = el;
        // construct
        this.construct = "FastjsDom";
        return this;
    }
    attr(key, value) {
        if (value !== undefined) {
            return value ? this._el.setAttribute(key, value.toString()) : this._el.removeAttribute(key), this;
        }
        return this._el.getAttribute(key);
    }
    addAfter(el) {
        if (!el.parentNode)
            _dev.newWarn("FastjsDom.addAfter", "el.parentNode is null", [
                "addAfter(el: HTMLElement)",
                "domEdit.ts",
                "FastjsDom"
            ]);
        else
            // add this._el after el
            el.parentNode.insertBefore(this._el, el.nextSibling);
        return this;
    }
    addBefore(el) {
        if (!el.parentNode)
            _dev.newWarn("FastjsDom.addAfter", "el.parentNode is null", [
                "addAfter(el: HTMLElement)",
                "domEdit.ts",
                "FastjsDom"
            ]);
        else
            // add this._el before el
            el.parentNode.insertBefore(this._el, el);
        return this;
    }
    addFirst(el) {
        // add this._el first in el
        return el.insertBefore(this._el, el.firstChild), this;
    }
    append(el) {
        return this._el.appendChild(el), this;
    }
    appendTo(el = _dev._dom.body) {
        return el.appendChild(this._el), this;
    }
    bind(bind, key, object = {}, isAttr = false) {
        if (bind === "html")
            bind = "innerHTML";
        if (bind === "text")
            bind = "innerText";
        return new FastjsBind(this, bind, key, object, isAttr);
    }
    css(key, value, other) {
        if (typeof key === "string") {
            // @ts-ignore
            this._el.style.setProperty(key, value, other);
        }
        else if (!key) {
            return this._el.style;
        }
        else {
            Object.entries(key).forEach((v) => {
                // @ts-ignore
                this._el.style[v[0]] = v[1];
            });
        }
        return this;
    }
    el() {
        return this._el;
    }
    each(callback) {
        // children each
        for (let i = 0; i < this._el.children.length; i++) {
            callback(new FastjsDom(this._el.children[i]), this._el.children[i], i);
        }
        return this;
    }
    focus() {
        this._el.focus();
        return this;
    }
    first() {
        return this._el.firstElementChild ? new FastjsDom(this._el.firstElementChild) : null;
    }
    father() {
        return new FastjsDom(this.el().parentNode);
    }
    get(key) {
        return this._el[key];
    }
    html(val) {
        // if null -> not change || String(val)
        this._el.innerHTML = val !== undefined ? val : this._el.innerHTML;
        return val !== undefined ? this : this._el.innerHTML;
    }
    last() {
        return this._el.lastElementChild ? new FastjsDom(this._el.lastElementChild) : null;
    }
    next(selecter) {
        return selector(selecter, this._el);
    }
    push(el = _dev._dom.body) {
        return el.appendChild(this._el), this;
    }
    on(event = "click", callback) {
        let eventTrig = (event) => callback(this, event);
        __classPrivateFieldGet(this, _FastjsDom_event, "f").push([callback, eventTrig]);
        this._el.addEventListener(event, eventTrig);
        return this;
    }
    off(event = "click", callback) {
        let del = null;
        __classPrivateFieldGet(this, _FastjsDom_event, "f").forEach((v, k) => {
            if (v[0] === callback) {
                this._el.removeEventListener(event, v[1]);
                del = k;
            }
        });
        if (del !== null)
            __classPrivateFieldGet(this, _FastjsDom_event, "f").splice(del, 1);
        return this;
    }
    remove() {
        return this._el.remove(), this;
    }
    set(key, val) {
        var _a, _b;
        if (((_a = Object.getOwnPropertyDescriptor(Element.prototype, key)) === null || _a === void 0 ? void 0 : _a.writable) ||
            ((_b = Object.getOwnPropertyDescriptor(Element.prototype, key)) === null || _b === void 0 ? void 0 : _b.set)) {
            this._el[key] = val;
        }
        else
            _dev.newWarn("FastjsDom.set", "key is not writable", [
                "key: " + key,
                "set<T extends keyof HTMLElement>(key: T, val: HTMLElement[T]): FastjsDom",
                "FastjsDom"
            ]);
        return this;
    }
    text(val) {
        // if null -> not change || String(val)
        this._el.innerText = val !== undefined ? val : this._el.innerText;
        return val !== undefined ? this : this._el.innerText;
    }
    then(callback, time = 0) {
        if (time)
            setTimeout(() => {
                callback(this, this.el());
            }, time);
        else
            callback(this, this.el());
        return this;
    }
    val(val) {
        const btn = this._el instanceof HTMLButtonElement;
        if (this._el instanceof HTMLInputElement || this._el instanceof HTMLTextAreaElement || this._el instanceof HTMLButtonElement) {
            // if val and is button || input || textarea
            if (val === undefined) {
                return btn ? this._el.innerText : this._el.value;
            }
            else {
                if (btn)
                    this._el.innerText = val;
                else
                    this._el.value = val;
            }
        }
        return this;
    }
}
_FastjsDom_event = new WeakMap();

// modules
const selecter = selector;

export { FastjsAjax, FastjsArray, FastjsDate, FastjsDom, FastjsDomList, copy, fastjs as default, rand, selecter, selector };
//# sourceMappingURL=fastjs-next-runtime-esm.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/fastjs-next/dist/fastjs-next-runtime-esm.js
// module id = bAQJ
// module chunks = 1